import * as awsui from "@cloudscape-design/design-tokens";
import { Navbar, Dropdown } from "@nextui-org/react"; // https://nextui.org/docs/components/navbar
import { icons } from "./icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import { navigateFn } from "../../routingHelper";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../context";


export default function NavLinks() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);

  const collapseNavBar = useMediaQuery({query: "only screen and (min-width : 900px)"});

  if (!collapseNavBar) return <></>
  
  return (
    <>
      <Navbar.Link 
        css={{ 
          color: awsui.colorTextBodyDefault,
        }} 
        isActive={location.pathname === "/"} 
        onClick={(event) => {
          event.preventDefault();
          navigate("/")
        }}
      >
          Home
      </Navbar.Link>
      <Dropdown>
        <Navbar.Item>
          <Dropdown.Button
            auto
            light
            css={{
              px: 0,
              dflex: "center",
              svg: { pe: "none" },
              color: awsui.colorTextBodyDefault,
            }}
            iconRight={icons.chevron}
            ripple={false}
          >
            Series
          </Dropdown.Button>
        </Navbar.Item>
        <Dropdown.Menu
          aria-label="Series Menu"
          variant="shadow"
          css={{
            background: awsui.colorBackgroundDropdownItemDefault,
            $$dropdownMenuWidth: "340px",
            $$dropdownItemHeight: "70px",
            "& .nextui-dropdown-item": {
              py: "$4",
              // dropdown item title
              "& .nextui-dropdown-item-content": {
                w: "100%",
                fontWeight: "$semibold",
              },
              '&:hover': {
                background: "$primary",
              },
              '&:active': {
                background: "$primary",
              },
              '&:focus': {
                background: "$primary",
              },
            },
          }}
          onAction={ ( actionKey ) => {
            setSeriesContent(actionKey.toString())
            navigate(actionKey.toString());
          }}
        >
          {/* <Dropdown.Item
            key="f3a-series"
            // variant="shadow"
            // showFullDescription
            // description="ACME scales apps to meet user demand, automagically, based on load."
          >
            F3 Australia
          </Dropdown.Item> */}
          <Dropdown.Item
            key="f4a-series"
            // variant="shadow"
            // showFullDescription
            // description="Real-time metrics to debug issues. Slow query added? We’ll show you exactly where."
          >
            F4 Australia
          </Dropdown.Item>
          <Dropdown.Item
            key="ffa-series"
            // variant="shadow"
            // showFullDescription
            // description="ACME runs on ACME, join us and others serving requests at web scale."
          >
            Formula Ford
          </Dropdown.Item>
          <Dropdown.Item
            key="s5000-series"
            // variant="shadow"
            // showFullDescription
            // description="Applications stay on the grid with high availability and high uptime guarantees."
          >
            S5000
          </Dropdown.Item>
          {/* <Dropdown.Item
            key="apjc-series"
            // variant="shadow"
            // showFullDescription
            // description="Overcome any challenge with a supporting team ready to respond."
          >
            Asia-Pacific Junior Esports Challenge
          </Dropdown.Item> */}
          <Dropdown.Item
            key="trinations-series"
            // variant="shadow"
            // showFullDescription
            // description="Overcome any challenge with a supporting team ready to respond."
          >
            Tri Nations Esports Cup
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      {/* <Navbar.Link 
        css={{ color: awsui.colorTextBodyDefault }} 
        isActive={location.pathname === "/news"} 
        onClick={(event) => {
          event.preventDefault();
          navigate("news")
        }}
      >
          News
      </Navbar.Link> */}
      {/* <Navbar.Link 
        css={{ color: awsui.colorTextBodyDefault }} 
        isActive={location.pathname === "/sponsors"} 
        onClick={(event) => {
          event.preventDefault();
          navigate("sponsors")
        }}
      >
          Sponsors
      </Navbar.Link> */}
      <Navbar.Link 
        css={{ color: awsui.colorTextBodyDefault }} 
        isActive={location.pathname === "/about"} 
        onClick={(event) => {
          event.preventDefault();
          navigate("about")
        }}
      >
          Privacy
      </Navbar.Link>
    </>
  );
}
